<template>
  <footer>
    <!--立即估价 | 查看估价-->
    <van-button
      :class="[canClick ? 'btn-active' : '', 'btn-photo']"
      @click="submit"
      :disabled="!canClick"
      :loading="loading"
      loading-text="Siguiente"
      loading-type="spinner"
      > {{ $t('PCButton.index.646zhxujd5g0') }}</van-button
    >
  </footer>
</template> 

<script>
export default {
  props: ["canClick", "loading"],
  data() {
    return {};
  },
  methods: {
    submit() {
      this.$emit("submit");
    },
  },
  computed: {
    /**
     * 进度条长度
     */
    progressBarWidth() {
      return (this.current / this.total) * 100;
    },
  },
};
</script>

<style lang="less" scoped>
footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 10px 24px !important;
  font-size: 28px;
  // box-shadow: 0px -2px 8px 0px rgba(144, 151, 166, 0.1);
  .btn-photo {
    height: 80px;
    width: 100%;
    text-align: center;
    line-height: 80px;
    background: #405FFF !important;
    color: #fff !important;
    border-radius: 5px;
    opacity: 0.5;
    border-radius: 16px;
  }
  .btn-active {
    background: #405FFF !important;
    color: #fff !important;
    opacity: 1 !important;
  }
}
</style>
